module.exports = __webpack_public_path__ + "img/home.24ed1efb.jpg";